@if (messageStackExpanded) {
@for (email of messageStack; track $index) {
<div class="message-stack-item">
    <div class="message-content-wrapper">
        <div>
            <div class="user-img">
                @if (
                email.receiver_email === ''
                ) {
                <span class="color-black">T</span>
                } @else {
                <span class="color-black">{{email.receiver_email.split('@')[0][0]}}</span>
                }
            </div>
        </div>
        <div class="message-user-section">
            <div>
                <div class="message-header-row">
                    @if (
                    email.receiver_email === ''
                    ) {
                    <span class="color-black">Tech</span>
                    } @else {
                    <span class="color-black">{{email.receiver_email.split('@')[0]}}</span>
                    }
                    <div class="message-date-time-wrapper">
                        <img src="../../../assets/vectors/Ellipse 154.svg" alt="">
                        <span>{{ email.email_formatted_date }}</span>
                        <img src="../../../assets/vectors/Ellipse 154.svg" alt="">
                        <span>{{ email.email_formatted_time }}</span>
                        <span class="v-rule message-separator-line"></span>
                    </div>
                    <div class="reply-button-wrapper" (click)="showReplyBox(email)">
                        <img src="../../../assets/vectors/Vector.svg" class="reply-icon" alt="Reply">
                        <span class="reply-text">Reply</span>
                    </div>
                </div>
                <div class="message-recipients-section">

                    <!-- To Field -->
                    <div class="recipient-row">
                        <span class="recipient-label">To</span>
                        <div class="recipient-content">
                            @if (email.receiver_email === '') {
                            <span class="recipient-name">"{{ currentUserName }}"</span>
                            <span class="recipient-email">&lt;{{ currentUserEmail }}&gt;</span>
                            } @else {
                            <span class="recipient-name">"Tech"</span>
                            <span class="recipient-email">&lt;tech&#64;tlregtech.com&gt;</span>
                            }
                        </div>
                    </div>

                    <!-- Cc Field -->
                    <div class="recipient-row">
                        <span class="recipient-label">Cc</span>
                        <div class="recipient-content">
                            @if (participantsList.length > 0) {
                            @for (participant of participantsList; track $index; let isLast = $last) {
                            <span class="recipient-name">"{{ participant.split('@')[0] }}"</span>
                            <span class="recipient-email">&lt;{{ participant }}&gt;</span>
                            @if (!isLast) {
                            <span class="recipient-separator">,</span>
                            <span class="recipient-space"></span>
                            }
                            }
                            } @else {
                            <span class="no-participants-text">No participants</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div [innerHTML]="email.email_body" class="email-body"></div>
            </div>
            @if ( email.attachment.length > 0 ) {
            <p class="attachments-title">Attachment(s)</p>
            }
            @for (item of email.attachment; track $index) {
            <div class="file-chip-attachement">
                <button type="button" (click)="downloadAttachment(item)" [title]="item">
                    {{ item }}
                </button>
            </div>
            }
        </div>
    </div>
    <div class="reply-box" *ngIf="email.reply_box_flag">
        <form #replyForm="ngForm" (submit)="replyToMessage()">
            <div class="reply-editor">
                <div class="message-form-header">Replying to Tech</div>
                <ejs-richtexteditor #rte (created)="onRteCreated()" name="replyMessage" [(ngModel)]="replyMessage"
                    [toolbarSettings]="tools" [fontFamily]="fontFamily" [fontSize]="fontSize"
                    [insertImageSettings]="insertImageSettings" placeholder="Reply..."
                    [width]="'100%'" (imageSelected)="onImageSelected($event)">
                </ejs-richtexteditor>
                <!-- Send belongs to the editor's toolbar row, at its left end. Syncfusion
                     renders that row, so the button is laid over it from here. -->
                <button type="submit" class="send-btn">
                    <img src="../../../assets/vectors/Group 1059.svg" alt="Send">
                    <span>Send</span>
                </button>
            </div>
            <div class="reply-form-buttons">
                <button type="button" class="upload-files-btn" (click)="triggerFileInput()">
                    <img src="../../../assets/vectors/upload 2.svg" alt="Upload Files">
                    <span>Upload Files</span>
                </button>
                <input type="file" #fileInput class="file-input-hidden" (change)="handleFileSelect($event)" multiple>

                <div class="attachment-info-wrapper">
                    @if (uploadedFilesArray.length === 0) {
                    <p class="no-attachments-text">
                        No attachments added yet.
                    </p>
                    }
                    @else if (uploadedFilesArray.length > 0) {
                    <ul class="attachments-list">
                        @for (file of uploadedFilesArray; track $index) {
                        @if (file.type === 'image/png') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/PNG Icon.svg" alt="PNG File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'application/pdf') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/Pdf icon.svg" alt="PDF File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'text/plain') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/TXT Icon.svg" alt="TXT File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'video/mp4') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/Screen Recording Icon.svg" alt="MP4 File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'application/zip') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/ZIP icon.svg" alt="ZIP File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else {
                        <div class="file-chip">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        }
                        }
                    </ul>
                    }
                    <p *ngIf="fileUploadErrorMessage" class="file-upload-error">
                        *{{
                        fileUploadErrorMessage }}</p>

                </div>
            </div>
        </form>
    </div>
</div>
}
}
@else {
@for (email of messageStack.slice(0,1); track $index) {
<div class="message-stack-item">
    <div class="message-content-wrapper">
        <div>
            <div class="user-img">
                @if (
                email.receiver_email === ''
                ) {
                <span class="color-black">T</span>
                } @else {
                <span class="color-black">{{email.receiver_email.split('@')[0][0]}}</span>
                }
            </div>
        </div>
        <div class="message-user-section">
            <div>
                <div class="message-header-row">
                    @if (
                    email.receiver_email === ''
                    ) {
                    <span class="color-black">Tech</span>
                    } @else {
                    <span class="color-black">{{email.receiver_email.split('@')[0]}}</span>
                    }
                    <div class="message-date-time-wrapper">
                        <img src="../../../assets/vectors/Ellipse 154.svg" alt="">
                        <span>{{ email.email_formatted_date }}</span>
                        <img src="../../../assets/vectors/Ellipse 154.svg" alt="">
                        <span>{{ email.email_formatted_time }}</span>
                        <span class="v-rule message-separator-line"></span>
                    </div>
                    <div class="reply-button-wrapper" (click)="showReplyBox(email)">
                        <img src="../../../assets/vectors/Vector.svg" class="reply-icon" alt="Reply">
                        <span class="reply-text">Reply</span>
                    </div>
                </div>
                <div class="message-recipients-section">

                    <!-- To Field -->
                    <div class="recipient-row">
                        <span class="recipient-label">To</span>
                        <div class="recipient-content">
                            @if (email.receiver_email === '') {
                            <span class="recipient-name">"{{ currentUserName }}"</span>
                            <span class="recipient-email">&lt;{{ currentUserEmail }}&gt;</span>
                            } @else {
                            <span class="recipient-name">"Tech"</span>
                            <span class="recipient-email">&lt;tech&#64;tlregtech.com&gt;</span>
                            }
                        </div>
                    </div>

                    <!-- Cc Field -->
                    <div class="recipient-row">
                        <span class="recipient-label">Cc</span>
                        <div class="recipient-content">
                            @if (participantsList.length > 0) {
                            @for (participant of participantsList; track $index; let isLast = $last) {
                            <span class="recipient-name">"{{ participant.split('@')[0] }}"</span>
                            <span class="recipient-email">&lt;{{ participant }}&gt;</span>
                            @if (!isLast) {
                            <span class="recipient-separator">,</span>
                            <span class="recipient-space"></span>
                            }
                            }
                            } @else {
                            <span class="no-participants-text">No participants</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div [innerHTML]="email.email_body" class="email-body"></div>
            </div>
            @if ( email.attachment.length > 0 ) {
            <p class="attachments-title">Attachment(s)</p>
            }
            @for (item of email.attachment; track $index) {
            <div class="file-chip-attachement">
                <button type="button" (click)="downloadAttachment(item)" [title]="item">
                    {{ item }}
                </button>
            </div>
            }
        </div>
    </div>
    <div class="reply-box" *ngIf="email.reply_box_flag">
        <form #replyForm="ngForm" (submit)="replyToMessage()">
            <div class="reply-editor">
                <div class="message-form-header">Replying to Tech</div>
                <ejs-richtexteditor #rte (created)="onRteCreated()" name="replyMessage" [(ngModel)]="replyMessage"
                    [toolbarSettings]="tools" [fontFamily]="fontFamily" [fontSize]="fontSize"
                    [insertImageSettings]="insertImageSettings" placeholder="Reply..."
                    [width]="'100%'" (imageSelected)="onImageSelected($event)">
                </ejs-richtexteditor>
                <!-- Send belongs to the editor's toolbar row, at its left end. Syncfusion
                     renders that row, so the button is laid over it from here. -->
                <button type="submit" class="send-btn">
                    <img src="../../../assets/vectors/Group 1059.svg" alt="Send">
                    <span>Send</span>
                </button>
            </div>
            <div class="reply-form-buttons">
                <button type="button" class="upload-files-btn" (click)="triggerFileInput()">
                    <img src="../../../assets/vectors/upload 2.svg" alt="Upload Files">
                    <span>Upload Files</span>
                </button>
                <input type="file" #fileInput class="file-input-hidden" (change)="handleFileSelect($event)" multiple>

                <div class="attachment-info-wrapper">
                    @if (uploadedFilesArray.length === 0) {
                    <p class="no-attachments-text">
                        No attachments added yet.
                    </p>
                    }
                    @else if (uploadedFilesArray.length > 0) {
                    <ul class="attachments-list">
                        @for (file of uploadedFilesArray; track $index) {
                        @if (file.type === 'image/png') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/PNG Icon.svg" alt="PNG File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'application/pdf') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/Pdf icon.svg" alt="PDF File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'text/plain') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/TXT Icon.svg" alt="TXT File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'video/mp4') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/Screen Recording Icon.svg" alt="MP4 File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'application/zip') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/ZIP icon.svg" alt="ZIP File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else {
                        <div class="file-chip">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        }
                        }
                    </ul>
                    }
                    <p *ngIf="fileUploadErrorMessage" class="file-upload-error">
                        *{{
                        fileUploadErrorMessage }}</p>

                </div>
            </div>
        </form>
    </div>

    <button type="button" (click)="expandMessageStack()" class="expand-btn" (mouseenter)="isButtonHovered = true"
        (mouseleave)="isButtonHovered = false">
        @if (isButtonHovered) {
        <img src="../../../assets/vectors/Group 1203.svg" class="expand-icon" alt="">
        } @else {
        <span class="expand-count">
            {{ messageStack.length - 3 }}
        </span>
        }
    </button>
</div>
}

@for (email of messageStack.slice(-2); track $index) {
<div class="message-stack-item">
    <div class="message-content-wrapper">
        <div>
            <div class="user-img">
                @if (
                email.receiver_email === ''
                ) {
                <span class="color-black">T</span>
                } @else {
                <span class="color-black">{{email.receiver_email.split('@')[0][0]}}</span>
                }
            </div>
        </div>
        <div class="message-user-section">
            <div>
                <div class="message-header-row">
                    @if (
                    email.receiver_email === ''
                    ) {
                    <span class="color-black">Tech</span>
                    } @else {
                    <span class="color-black">{{email.receiver_email.split('@')[0]}}</span>
                    }
                    <div class="message-date-time-wrapper">
                        <img src="../../../assets/vectors/Ellipse 154.svg" alt="">
                        <span>{{ email.email_formatted_date }}</span>
                        <img src="../../../assets/vectors/Ellipse 154.svg" alt="">
                        <span>{{ email.email_formatted_time }}</span>
                        <span class="v-rule message-separator-line"></span>
                    </div>
                    <div class="reply-button-wrapper" (click)="showReplyBox(email)">
                        <img src="../../../assets/vectors/Vector.svg" class="reply-icon" alt="Reply">
                        <span class="reply-text">Reply</span>
                    </div>
                </div>
                <div class="message-recipients-section">

                    <!-- To Field -->
                    <div class="recipient-row">
                        <span class="recipient-label">To</span>
                        <div class="recipient-content">
                            @if (email.receiver_email === '') {
                            <span class="recipient-name">"{{ currentUserName }}"</span>
                            <span class="recipient-email">&lt;{{ currentUserEmail }}&gt;</span>
                            } @else {
                            <span class="recipient-name">"Tech"</span>
                            <span class="recipient-email">&lt;tech&#64;tlregtech.com&gt;</span>
                            }
                        </div>
                    </div>

                    <!-- Cc Field -->
                    <div class="recipient-row">
                        <span class="recipient-label">Cc</span>
                        <div class="recipient-content">
                            @if (participantsList.length > 0) {
                            @for (participant of participantsList; track $index; let isLast = $last) {
                            <span class="recipient-name">"{{ participant.split('@')[0] }}"</span>
                            <span class="recipient-email">&lt;{{ participant }}&gt;</span>
                            @if (!isLast) {
                            <span class="recipient-separator">,</span>
                            <span class="recipient-space"></span>
                            }
                            }
                            } @else {
                            <span class="no-participants-text">No participants</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div [innerHTML]="email.email_body" class="email-body"></div>
            </div>
            @if ( email.attachment.length > 0 ) {
            <p class="attachments-title">Attachment(s)</p>
            }
            @for (item of email.attachment; track $index) {
            <div class="file-chip-attachement">
                <button type="button" (click)="downloadAttachment(item)" [title]="item">
                    {{ item }}
                </button>
            </div>
            }
        </div>
    </div>
    <div class="reply-box" *ngIf="email.reply_box_flag">
        <form #replyForm="ngForm" (submit)="replyToMessage()">
            <div class="reply-editor">
                <div class="message-form-header">Replying to Tech</div>
                <ejs-richtexteditor #rte (created)="onRteCreated()" name="replyMessage" [(ngModel)]="replyMessage"
                    [toolbarSettings]="tools" [fontFamily]="fontFamily" [fontSize]="fontSize"
                    [insertImageSettings]="insertImageSettings" placeholder="Reply..."
                    [width]="'100%'" (imageSelected)="onImageSelected($event)">
                </ejs-richtexteditor>
                <!-- Send belongs to the editor's toolbar row, at its left end. Syncfusion
                     renders that row, so the button is laid over it from here. -->
                <button type="submit" class="send-btn">
                    <img src="../../../assets/vectors/Group 1059.svg" alt="Send">
                    <span>Send</span>
                </button>
            </div>
            <div class="reply-form-buttons">
                <button type="button" class="upload-files-btn" (click)="triggerFileInput()">
                    <img src="../../../assets/vectors/upload 2.svg" alt="Upload Files">
                    <span>Upload Files</span>
                </button>
                <input type="file" #fileInput class="file-input-hidden" (change)="handleFileSelect($event)" multiple>

                <div class="attachment-info-wrapper">
                    @if (uploadedFilesArray.length === 0) {
                    <p class="no-attachments-text">
                        No attachments added yet.
                    </p>
                    }
                    @else if (uploadedFilesArray.length > 0) {
                    <ul class="attachments-list">
                        @for (file of uploadedFilesArray; track $index) {
                        @if (file.type === 'image/png') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/PNG Icon.svg" alt="PNG File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'application/pdf') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/Pdf icon.svg" alt="PDF File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'text/plain') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/TXT Icon.svg" alt="TXT File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'video/mp4') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/Screen Recording Icon.svg" alt="MP4 File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else if (file.type === 'application/zip') {
                        <div class="file-chip">
                            <img src="../../../assets/vectors/ZIP icon.svg" alt="ZIP File">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        } @else {
                        <div class="file-chip">
                            {{ file.name }}
                            <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                    (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                        </div>
                        }
                        }
                    </ul>
                    }
                    <p *ngIf="fileUploadErrorMessage" class="file-upload-error">
                        *{{
                        fileUploadErrorMessage }}</p>

                </div>
            </div>
        </form>
    </div>
</div>
}
} 